import { rem } from 'polished';
import styled from 'styled-components';
import { getMaxPageWidth } from '../../constants';
import { breakpoints } from '../../styles/theme';

export const Wrapper = styled.div`
    font-size: ${({ theme }) => theme.fontSizes.h6};
    line-height: ${rem(30)};

    li {
        padding-bottom: ${rem(4)};
    }

    @media (min-width: ${breakpoints.md}px) {
        padding: ${rem(20)} 0;
    }
`;

export const Title = styled.h2`
    font-weight: ${({ theme }) => theme.fontWeights.textBold};
    font-size: ${({ theme }) => theme.fontSizes.h4};
    padding: ${rem(40)} 0 ${rem(25)} 0;
    display: block;
`;

export const Program = styled.div<{ withBorder: boolean }>`
    padding-bottom: ${rem(20)};
    border-bottom: ${(props) => (props.withBorder ? `2px solid ${props.theme.colors.secondaryGrey}` : 'unset')};
    line-height: ${rem(22)};

    a, h4 span {
        color: ${({ theme }) => theme.colors.primary} !important;
    }
`;

export const Experience = styled.div`
    background: ${({ theme }) => theme.colors.darkLight};
    padding: ${rem(20)};
    margin-top: ${rem(40)};
    border-radius: ${rem(8)};
`;

export const Information = styled.div`
    padding-bottom: ${rem(20)};
    border-bottom: 2px solid ${({ theme }) => theme.colors.secondaryGrey};

    a {
        color: ${({ theme }) => theme.colors.primary};
    }
`;
